import { oc } from '@orpc/contract';
import * as z from 'zod';
import { ageBandSchema, childProfileSchema, childSchema } from '../domain/child.js';
import { childIdSchema } from '../primitives/id.js';
import { API_VERSION } from './version.js';
const base = `/${API_VERSION}/children`;
export const childWithProfileSchema = z.object({
    child: childSchema,
    profile: childProfileSchema,
});
export const childrenContract = {
    list: oc
        .route({ method: 'GET', path: base })
        .output(z.object({ children: z.array(childWithProfileSchema) })),
    get: oc
        .route({ method: 'GET', path: `${base}/{childId}` })
        .input(z.object({ childId: childIdSchema }))
        .output(childWithProfileSchema)
        .errors({ CHILD_NOT_FOUND: { status: 404, message: 'Child not found' } }),
    /**
     * A new child arrives with a usable default profile.
     *
     * An empty schedule denies everything (SPEC.md §17), so a child created
     * without one could open nothing and the parent would reasonably conclude the
     * product was broken. The server supplies sensible defaults; the parent edits
     * them.
     */
    create: oc
        .route({ method: 'POST', path: base })
        .input(z.object({
        name: z.string().min(1).max(40),
        ageBand: ageBandSchema,
        avatarKey: z.string().min(1).max(40),
    }))
        .output(childWithProfileSchema)
        .errors({
        CHILD_LIMIT_REACHED: { status: 402, message: 'Subscription does not allow another child' },
    }),
    updateProfile: oc
        .route({ method: 'PATCH', path: `${base}/{childId}/profile` })
        .input(z.object({
        childId: childIdSchema,
        profile: childProfileSchema.omit({ childId: true }).partial(),
    }))
        .output(childWithProfileSchema)
        .errors({ CHILD_NOT_FOUND: { status: 404, message: 'Child not found' } }),
};
//# sourceMappingURL=children.js.map